import type { FC } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Barcode from 'src/presentation/components/molecules/Barcode';
import {
	ReservationDate,
	ReservationPersons,
	ReservationTime,
} from 'src/presentation/components/molecules/ReservationAttributes';
import BottomSheet from 'src/presentation/components/organisms/BottomSheet';
import { useReservationsStore } from 'src/domain/stores/useReservationsStore';
import Colors from 'src/core/utils/Colors';
import Constants from 'src/core/utils/Constants';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';
import Translations from 'src/core/utils/Translations';

const ReservationBarcodeDialog: FC = () => {
	const { reservation, isBarcodeDialogVisible, closeBarcodeDialog } = useReservationsStore();

	const barcode = reservation?.barcode ?? null;

	if (!isBarcodeDialogVisible || reservation === null || barcode === null) {
		return null;
	}

	return (
		<BottomSheet visible={true} onClose={closeBarcodeDialog}>
			<Text style={styles.title}>{reservation.name || Translations.notAvailableShort}</Text>
			<View style={styles.attributes}>
				<ReservationDate arrivalDate={reservation.arrival_date} />
				<ReservationTime arrivalTime={reservation.arrival_time} />
				<ReservationPersons personsCount={reservation.persons_count} />
			</View>
			<Barcode barcode={barcode.toString()} format={Constants.barcodeFormatCode128} />
		</BottomSheet>
	);
};

const styles = StyleSheet.create({
	title: {
		fontFamily: Fonts.ptSerif,
		fontSize: Dimens.fontSize19,
		color: Colors.gray900,
	},
	attributes: {
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
});

export default ReservationBarcodeDialog;
